import React from "react";
import PrivacyPolicy from "./PrivacyPolicy";

function App() {
  return (
    <div>
      <PrivacyPolicy />
    </div>
  );
}

export default App;
